// @ vendors
const React = require('react');
const PropTypes = require('prop-types');
const { connect } = require('react-redux');

const authorizeBizum = require('actions/contactCenter/authorizeBizum');
const UserData = require('actions/contactCenter/userData');
const profile = require('actions/profile');

// @components
 const AuthorizeBizumView = require('components/contactCenter/bizum/authorizeBizum/authorizeBizum');

class AuthorizeBizumViewContainer extends React.Component {

    render() {
       return (
           <AuthorizeBizumView {...this.props} />
        );
    }
}

AuthorizeBizumViewContainer.propTypes = {
    immAuthorizeBizum: PropTypes.object.isRequired,
    immProfileFields : PropTypes.object.isRequired,
    immUserDataPhone : PropTypes.object.isRequired,
    immAccounts: PropTypes.object.isRequired,
    immProfileEditor: PropTypes.object,
    validateStep: PropTypes.func.isRequired,
    setVisibleStep :  PropTypes.func.isRequired,
    onSendTermsAndConditions: PropTypes.func.isRequired,
    onAcceptTermsAndConditions: PropTypes.func.isRequired,
    onAccountChange: PropTypes.func.isRequired,
    handleFinish: PropTypes.func.isRequired,
    requestPhoneOTP : PropTypes.func.isRequired,
    UserDataReset :  PropTypes.func.isRequired,
    onSetError: PropTypes.func.isRequired,
    onBizumDataReset :  PropTypes.func.isRequired,
    requestProfile : PropTypes.func
}

module.exports.AuthorizeBizumViewContainer = connect(state => ({
    immAuthorizeBizum: state.authorizeBizum,
    immProfileFields: state.profile,
    immUserDataPhone : state.userData,
    immProfileEditor: state.profileEditor,
    immAccounts: state.accounts
}), {
    validateStep : authorizeBizum.validateStep,
    setVisibleStep : authorizeBizum.setVisibleStep,
    requestPhoneOTP: UserData.GetPhoneBizum,
    UserDataReset :UserData.UserDataReset,
    onAccountChange : authorizeBizum.onAccountChange,
    handleFinish: authorizeBizum.postAuthorizeBizum,
    onSendTermsAndConditions: authorizeBizum.sendTermsConditions,
    onAcceptTermsAndConditions: authorizeBizum.onAcceptTermsAndConditions,
    onSetError: authorizeBizum.requestBizumSetError,
    onBizumDataReset:  authorizeBizum.BizumDataReset,
    requestProfile: profile.requestProfile,
})(AuthorizeBizumViewContainer);
